export default __webpack_public_path__ + "static/media/Prijava.001e354c.pdf";